module.exports = [{"type":"title","text":"2024-11-19"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perpetual: Added 'One-Click Reverse Position' interface."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-11-19.json
// module id = Jf4T
// module chunks = 3